/* eslint-disable camelcase */

import { colors } from '@lmc/common/constants'
import type { CbCustomer, CbSubscription } from '@lmc/common/types'
import {
  AccountDetails,
  Button,
  HeaderSection,
  LabelIcon,
  OverdueBillIcon,
  SubscriptionTable
} from '@lmc/ui-kit'
import { Skeleton } from 'antd'
import React from 'react'
import { history } from '../../../store'
import style from './index.module.less'
import { filterDuplicateSubscriptions } from './utils'

type Props = {
  activeResidentsCount: number
  openChargebeePortal: () => void
  peopleNominative: string
  subscriptions: Array<CbSubscription>
  customer: CbCustomer
}

const renderSpinner = () => (
  <div style={{ marginTop: 48 }}>
    <Skeleton active />
  </div>
)

export const Dashboard = ({
  subscriptions,
  customer,
  openChargebeePortal,
  activeResidentsCount,
  peopleNominative
}: Props) => {
  const isLoading = !subscriptions || !customer
  // @ts-ignore
  const isOverdue = !!subscriptions.find((sub) => sub.due_invoices_count > 0)
  const isFreeCustomer = !subscriptions.length

  return (
    <div className={style.container} style={{ paddingTop: 24 }}>
      <HeaderSection
        title={
          isOverdue ? (
            <div className={style.billingWithIcon}>
              Billing
              <OverdueBillIcon />
            </div>
          ) : (
            'Billing'
          )
        }
        onClick={history.back}
        rightChildren={
          isFreeCustomer ? undefined : (
            <Button onClick={openChargebeePortal} variant="primary">
              Manage
            </Button>
          )
        }
      />
      {isLoading ? (
        renderSpinner()
      ) : (
        <>
          <SubscriptionTable
            subscriptions={filterDuplicateSubscriptions(subscriptions)}
          />
          <AccountDetails
            openChargebee={openChargebeePortal}
            customer={customer}
            peopleNominative={peopleNominative}
            activeResidentsCount={activeResidentsCount}
            showChargeDetails={!isFreeCustomer}
          />
          <LabelIcon
            iconColor={colors.informationblue}
            iconName="QuestionCircleOutlined"
            onPress={() =>
              window.open(
                'https://support.logmycare.co.uk/en/collections/794841-faqs',
                '_blank'
              )
            }
            text="Help"
            textColor={colors.informationblue}
          />
        </>
      )}
    </div>
  )
}

export default Dashboard
